const getScheduleAttributes = () => {
  return [{ key: 'workflowStartedOn', label: 'Workflow Started On', dataType: 'date' }];
};

export default getScheduleAttributes;
